import { retrieveFromStorage } from "../../Components/Functions";
import Api from "../../Server/Api";
import { USER_AUTHENTICATION_DATA } from "../User/types";
import { UPDATE } from "./types";


const api = new Api();


export const updateProfile = (username, callback) => {
	return async (dispatch) => {
		const res = await api.get({ endpoint: "users/" + username + "/profile/" });
		const rev = await api.get({ endpoint: "users/" + username + "/reviews/" });
		dispatch({ type: UPDATE, reviews: rev, profile: res });
		callback && callback({ profile: res });
	}
};

export const getMoreReviews = (data={}) => {
	return async (dispatch) => {
		if(data?.reviews?.next){
			const page = Number(new URL(data?.reviews?.next).searchParams.get("page"));
			if(page > 0 && data?.reviews?.count > data?.reviews?.results?.length){
				dispatch({ type: UPDATE, ...data, reviews: { ...data.reviews, isLoading: true } });
				const rev = await api.get({ endpoint: "users/" + data?.username + "/reviews/?page="+page });
				if(rev?.results?.length > 0) {
					let _data = [...data?.reviews?.results, ...rev?.results].filter((v,i,a)=>a.findIndex(t=>(t.id === v.id))===i)
					const reviews = { ...rev, isLoading: false, results: _data }
					data.reviews = reviews;
					dispatch({ type: UPDATE, ...data });
				}
			}
		}
	}
};
